import { type TFunction } from 'i18next';

export const getOptionalLabel = (t: TFunction, isRequired: boolean, optionalFields?: boolean) => {
  if (isRequired) return '';
  return optionalFields ? t('common:optionalLabel') : '';
};
